// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nh-0";
export var fileList = "_nh-2";
export var removeFileButton = "_nh-1";